// extracted by mini-css-extract-plugin
module.exports = {"mainContainerStyle":"Subheader_mainContainerStyle__3ouS5","centerStyle":"Subheader_centerStyle__D8oHO","subHeaderStyle":"Subheader_subHeaderStyle__38wMt"};